import * as THREE from "https://esm.sh/three@0.169.0";
import { OrbitControls } from "https://esm.sh/three@0.169.0/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "https://esm.sh/three@0.169.0/examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "https://esm.sh/three@0.169.0/examples/jsm/postprocessing/EffectComposer.js";
import { RenderPass } from "https://esm.sh/three@0.169.0/examples/jsm/postprocessing/RenderPass.js";
// import poloCoaModel from './assets/Raglan.glb';
// import fabric1 from './assets/fabrics/color2.png';
// import uv1 from './assets/fabrics/uv2.png';
// import fabric2 from './assets/fabrics/color.jpeg';
// import uv2 from './assets/fabrics/uv.png';
// import buttonFabric3 from './assets/fabrics/C221-2.png';
// import buttonFabric2 from './assets/fabrics/MH1_Black-with-small-stain.png';
// import buttonFabric1 from './assets/fabrics/MH3_Dark-Brown_.png';

// ----- Global Variables -----
let scene, camera, renderer, controls, suitGroup, composer, renderPass;
let aLight = [], dirLight2, dirLight3, backLight;
let cameraFollowLight; // Add this new variable
const loadedMeshes = {};

// Remove GUI variables and keep only the light offset
let lightOffset = {
  x: -20,
  y: 16.8,
  z: 10
};

// Remove lapel-related variables
let currentButtoning, currentShoulder, currentMartingaleBelt, currentInvertedBoxPleat = true, currentVent, currentFront, currentChestPocket, currentSidePocket, currentSleeveDesign, currentLinings, currentButtonfab = 'Horn_Black_(MH1)', sCurruntFabric, currentLiningsColor = '#FFFFFF';
let allfabrics, defaultfabriccode = "";

// Add collar-related variables
let currentCollar = 'unconstructed';

const bodyElement = document.querySelector("body");
const dataPageValue = bodyElement.getAttribute("data-page");

const DEFAULT_FABRIC_TEXTURE_URL ="https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/default/Poly_Wool_Fabric_Base_Map.jpg";

// Fallback fabric object when fetched/selected fabric is null.
// Ensures we still render using DEFAULT_FABRIC_TEXTURE_URL.
const DEFAULT_FABRIC_FALLBACK = {
    repeatable_color_image_url: null,
    repeatable_normal_image_url: null,
    color_r: 128,
    color_g: 128,
    color_b: 128,
    tiling_info: { color_tiling_x: 1, color_tiling_y: 1 },
};

// ----- Configuration Data -----
const CONFIG = {
  defaults: {
    buttoning: 'Unconstructed',
    shoulder: 'Unconstructed',
    martingaleBelt: true,
    invertedBoxPleat: true,
    chestPocket: "boat",
    sidePocket: "slanted-welt-buttons",
    sleeveDesign: "sleeve-strap-with-buttons",
    linings: true,
    fabric: "fabric1",
    buttonFabric: currentButtonfab, // Add button fabric default
    liningFabric: currentLiningsColor,  // Add lining fabric default
    collar: "unconstructed" // Add collar default
  },

  assets: {
    buttoning: {
      Unconstructed: '0mm_Buttons',
      Lightly_Padded: '2mm_Button',
    },
    shoulder: {
      Unconstructed: '_Unconstructed',
      Lightly_Padded: '_Lightly_Padded'
    },

  },
  // // Add fabric assets mapping
  // fabrics: {
  //   fabric1: {
  //     color: fabric1,
  //     normal: uv1,
  //     name: 'Charcoal Grey'
  //   },
  //   fabric2: {
  //     color: fabric2,
  //     normal: uv2,
  //     name: 'Light Beige'
  //   }
  // },

  // // Add button fabric assets mapping
  // buttonFabrics: {
  //   'button-fabric1': {
  //     color: buttonFabric1, // MH3_Dark-Brown_.png
  //     normal: '',
  //     name: 'Dark Brown'
  //   },
  //   'button-fabric2': {
  //     color: buttonFabric2, // MH1_Black-with-small-stain.png
  //     normal: '',
  //     name: 'Black'
  //   },
  //   'button-fabric3': {
  //     color: buttonFabric3, // C221-2.png
  //     normal: '',
  //     name: 'Navy'
  //   }
  // },

  // // Add lining fabric assets mapping
  // liningFabrics: {
  //   'lining-fabric1': {
  //     color: fabric1,
  //     normal: uv1,
  //     name: 'Charcoal Grey'
  //   },
  //   'lining-fabric2': {
  //     color: fabric2,
  //     normal: uv2,
  //     name: 'Light Beige'
  //   }
  // }
};

// 1759238774275

// Add new global variables for the flow control
let selectedMainFabric = null;
let currentScreen = 'fabric-selection'; // 'fabric-selection' or 'config'
fetchFabrics()

// ----- Three.js Initialization -----
function initThree() {
  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf0f0f0);

  // Get the viewer div dimensions
  const viewerDiv = document.getElementById('CanvasFrame');
  const viewerWidth = viewerDiv.clientWidth;
  const viewerHeight = viewerDiv.clientHeight;

  camera = new THREE.OrthographicCamera(
    viewerWidth / -720,
    viewerWidth / 720,
    viewerHeight / 720,
    viewerHeight / -720,
    1,
    1000
  );
  camera.position.set(0, 0, 12);
  camera.updateProjectionMatrix();
  camera.lookAt(0, 0, 0);

  renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    preserveDrawingBuffer: true,
    powerPreference: "high-performance",
  });

  renderer.shadowMap.enabled = true;
  renderer.gammaInput = true;
  renderer.gammaOutput = true;

  renderer.setSize(viewerWidth, viewerHeight);

  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;

  composer = new EffectComposer(renderer);
  renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  document.getElementById('CanvasFrame').appendChild(renderer.domElement);

  const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
  scene.add(ambientLight);

  backLight = new THREE.DirectionalLight(0xffffff, 2);
  scene.add(backLight);
  backLight.position.set(10, 0, 10);

  cameraFollowLight = new THREE.DirectionalLight(0xffffff, 3.9);
  cameraFollowLight.castShadow = true;
  cameraFollowLight.shadow.mapSize.width = 2048;
  cameraFollowLight.shadow.mapSize.height = 2048;
  cameraFollowLight.shadow.camera.near = 0.5;
  cameraFollowLight.shadow.camera.far = 50;
  cameraFollowLight.shadow.camera.left = -10;
  cameraFollowLight.shadow.camera.right = 10;
  cameraFollowLight.shadow.camera.top = 10;
  cameraFollowLight.shadow.camera.bottom = -10;
  scene.add(cameraFollowLight);

  // Controls
  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.enablePan = false;
  controls.minPolarAngle = Math.PI / 2;
  controls.maxPolarAngle = Math.PI / 2;
  controls.minZoom = 0.75;
  controls.maxZoom = 1.5;
  controls.enableZoom = false;
  controls.rotateSpeed = 0.5;
  controls.autoRotate = false;


  suitGroup = new THREE.Group();
  scene.add(suitGroup);

  // Remove GUI initialization
  // initGUI();
  loadJacketModel('https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/Raglan.glb');
  animate();
}

// Remove the entire initGUI function

function animate() {

  controls.update();

  if (cameraFollowLight) {
    const offset = new THREE.Vector3(lightOffset.x, lightOffset.y, lightOffset.z);
    offset.applyQuaternion(camera.quaternion);
    cameraFollowLight.position.copy(camera.position).add(offset);
    if (suitGroup) {
      cameraFollowLight.target.position.copy(suitGroup.position);
      cameraFollowLight.target.updateMatrixWorld();
    }
  }

  requestAnimationFrame(animate);
  composer.render();
}

function loadJacketModel(url) {
  const loader = new GLTFLoader();
  loader.load(url, async gltf => {
    const model = gltf.scene;
    suitGroup.clear();
    suitGroup.add(model);
    centerModel(model);
    await storeTopLevelGroups(model);  // Add await here
    fetchFabrics();
    applyDefaultConfig();              // Now this runs after meshes are stored
  }, undefined, function (error) {
    console.error('An error occurred loading the model:', error);
  });
}

function centerModel(model) {
  const box = new THREE.Box3().setFromObject(model);
  const center = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());

  model.position.sub(center);
  const maxDim = Math.max(size.x, size.y, size.z);
  const scale = 2 / maxDim;
  model.scale.setScalar(scale);
  box.setFromObject(model);
  const newCenter = box.getCenter(new THREE.Vector3());
  model.position.sub(newCenter);
}

function setAllMeshesInvisible(object) {
  object.traverse((child) => {
    child.visible = false;
  });
}

async function storeTopLevelGroups(root) {
  return new Promise((resolve) => {
    root.children.forEach(child => {
      if (child.name) {
        loadedMeshes[child.name] = child; // group of options
        setAllMeshesInvisible(child);
      }
    });

    console.log("Loaded meshes:", loadedMeshes);

    resolve();
  });
}

function updateVariant(groupName, visibleChildName, toggle = true, visibility = true) {
  const group = loadedMeshes[groupName]; // e.g., Buttons, Shoulder

  if (!group) {
    console.warn(`Group '${groupName}' not found`);
    return;
  }
  if (!group.visible) {
    group.visible = true;
  }

  if (group.isMesh) {
    group.visible = visibility;
    return;
  }

  if (visibleChildName === "none") {
    group.children.forEach(child => {
      child.visible = false;
    });
  } else {
    group.children.forEach(child => {
      if (child.name === visibleChildName) {
        child.visible = visibility; // Use the visibility parameter here
        child.traverse(subChild => {
          subChild.visible = visibility; // Also apply visibility to sub-children
        });
      } else {
        if (toggle) {
          child.visible = false;
        } else {
          child.visible = true;
        }
      }
    });
  }
}

function applyDefaultConfig() {
  updateVent(); 
  updateButtoning(CONFIG.defaults.buttoning);
  updateShoulder(CONFIG.defaults.shoulder);
  martingaleBelt(CONFIG.defaults.martingaleBelt);
  invertedBoxPleat(CONFIG.defaults.invertedBoxPleat);
  updateChestPocket(CONFIG.defaults.chestPocket);
  updateSidePocket(CONFIG.defaults.sidePocket);
  updateSleeveDesign(CONFIG.defaults.sleeveDesign);
  updateLinings();
  updateLiningFabric(CONFIG.defaults.liningFabric); 
  updateButtonFabric(CONFIG.defaults.buttonFabric);
}



///Start of update functions----------------------------------------------------------
function updateButtoning(styleKey, toggle = true, visibility = true) {
  const buttoningMap = {
    Unconstructed: '0mm_Buttons',
    Lightly_Padded: '2mm_Button',
    belt_buttons: 'belt_button',
    slanted_buttons: 'slated_button',
    one_strap: 'one_strap_button',
    pleat_buttons: 'pleat_buttons',
    sec_strap: 'sec_strap'
  };

  currentButtoning = styleKey;
  updateVariant('Buttons', buttoningMap[styleKey], toggle, visibility);
}

function updateVent() {
  if (currentInvertedBoxPleat === "false" || currentInvertedBoxPleat === false) {
    if (currentShoulder == "Unconstructed") {
      updateVariant('vents', "0mm_Vent", true, true);
    } else {
      updateVariant('vents', "2mm_Vent", true, true);
    }
  } else {
    if (currentShoulder == "Unconstructed") {
      updateVariant('vents', "0mm_Vent", true, false);
    } else {
      updateVariant('vents', "2mm_Vent", true, false);
    }
  }
}


function updateShoulder(styleKey) {
  const shoulderMap = {
    Unconstructed: '0mm_front',
    Lightly_Padded: '2mm_front',
  };


  currentShoulder = styleKey;

  updateCollar(styleKey);
  updateButtoning(styleKey)
  updateVent()
  updateChestPocket();

  if (currentShoulder == "Unconstructed") {
    updateVariant('sewing', "line", false, true);
  } else if (currentShoulder == "Lightly_Padded") {
    updateVariant('sewing', "line", false, false);
  }

  const shoulderGroup = loadedMeshes['Shoulder'];
  if (!shoulderGroup) {
    console.warn('Shoulder group not found');
    return;
  }

  shoulderGroup.visible = true;

  const targetName = shoulderMap[styleKey];
  let found = false;

  // Hide all variants; show only the target
  shoulderGroup.children.forEach((variant) => {
    const isTarget = variant.name === targetName;
    if (isTarget) found = true;

    variant.visible = isTarget;
    variant.traverse((subChild) => {
      subChild.visible = isTarget;
    });
  });

  if (!found) {
    console.warn(`Shoulder variant not found for "${styleKey}"`);
    // Ensure nothing is shown if we don't find the target
    shoulderGroup.children.forEach((variant) => {
      variant.visible = false;
      variant.traverse((subChild) => {
        subChild.visible = false;
      });
    });
  }
}


function martingaleBelt(styleKey, visibility = true) {
  currentMartingaleBelt = styleKey;
  updateVariant('belt', "Martingle_blet", true, visibility);
}


function invertedBoxPleat(styleKey = currentInvertedBoxPleat, visibility = true) {
  function updatePleatButtons(visibility) {
    const pleatButtonsGroup = loadedMeshes['Buttons'];
    if (pleatButtonsGroup) {
      pleatButtonsGroup.traverse((child) => {
        if (child.name === "pleat_button") {
          child.visible = visibility;
          child.traverse((subChild) => {
            subChild.visible = visibility;
          });
        }
      });
    }
  }

  if (styleKey == "false" || styleKey == false || styleKey == "true" || styleKey == true) {
    currentInvertedBoxPleat = styleKey;
  }

  if (currentInvertedBoxPleat === "false" || currentInvertedBoxPleat === false) {
    updateVariant('pleat', "none", true, false);
    updateVent(false);
    if (styleKey === "false") {
      updatePleatButtons(false);
    } else {
      updatePleatButtons(true);
    }
    return;
  }

  const shoulderConfig = currentShoulder || CONFIG.defaults.shoulder;

  // Map buttoning and shoulder configuration to the appropriate pleat variant
  const pleatVariantMap = {
    'Lightly_Padded': '2mm_invert_box_pleat',
    'Unconstructed': '0mm_inverted_pleat',
  };

  // Create the key based on buttoning and shoulder
  let pleatKey;
  pleatKey = `${shoulderConfig}`;

  const targetPleatVariant = pleatVariantMap[pleatKey];
  if (targetPleatVariant) {
    updatePleatButtons(styleKey);
    updateVent(false);
    updateVariant('pleat', targetPleatVariant, true, visibility);
  } else {
    console.warn(`No pleat variant found for buttoning: ${shoulderConfig}, shoulder: ${shoulderConfig}`);
  }
}

function updateChestPocket(styleKey = currentChestPocket) {
  currentChestPocket = styleKey;
  let targetStyleKey = styleKey;
  if (styleKey === 'boat') {
    targetStyleKey = currentShoulder;
  }
  const chestPocketMap = {
    'Unconstructed': '0mm_boat',
    'Lightly_Padded': '2mm_boat',
    'none': 'none',
  };
  updateVariant('ChestPocket', chestPocketMap[targetStyleKey]);
}

function updateSidePocket(styleKey) {
  const sidePocketMap = {
    'path-with-flaps': 'Patch',
    'slanted-welt': 'slanted',
    'slanted-welt-buttons': 'slanted',
  };
  currentSidePocket = styleKey;
  if (styleKey === 'slanted-welt-buttons') {
    updateVariant('Sidepocket', sidePocketMap[styleKey]);

    const buttonsGroup = loadedMeshes['Buttons'];
    if (buttonsGroup) {
      buttonsGroup.children.forEach(child => {
        if (child.name === "slated_button") {
          child.visible = true;
          child.traverse(subChild => {
            subChild.visible = true;
          });
        }
      });
    }
  } else {
    const buttonsGroup = loadedMeshes['Buttons'];
    if (buttonsGroup) {
      buttonsGroup.children.forEach(child => {
        if (child.name === "slated_button") {
          child.visible = false;
          child.traverse(subChild => {
            subChild.visible = false;
          });
        }
      });
    }
    updateVariant('Sidepocket', sidePocketMap[styleKey]);
  }
}

// Fix the sleeve design function to use correct mesh names
function updateSleeveDesign(styleKey) {
  const sleeveDesignMap = {
    'un-cuffed': 'un_cuffed',
    'cuffed': 'cuffed',
    'sleeve-strap': 'Sleeve_Strap',
    'sleeve-strap-with-buttons': 'Full_Sleeve_Strap_with_buttons'
  };

  // Handle sleeve-specific buttons separately without affecting main buttoning
  if (styleKey === 'sleeve-strap-with-buttons') {
    updateVariant('sleave_buttons', 'sec_strap', true);
  } else if (styleKey === 'sleeve-strap') {
    updateVariant('sleave_buttons', 'one_strap_button', true);
  } else if (styleKey === 'un-cuffed' || styleKey === 'cuffed') {
    updateVariant('sleave_buttons', 'none', true);
  }

  currentSleeveDesign = styleKey;
  updateVariant('Sleeve_design', sleeveDesignMap[styleKey]);
}

function updateLinings(visibility = true) {
  currentLinings = visibility;

  function updateSleeveLinings() {
    const sleeveLiningsGroup = loadedMeshes['lining'];
    if (sleeveLiningsGroup) {
      sleeveLiningsGroup.children.forEach(child => {
        if (child.name === "2mm_Lining" || child.name === "Lining") {
          child.visible = visibility;
          child.traverse(subChild => {
            subChild.visible = visibility;
          });
        }
      });
    }
  }

  updateVariant('lining', 'Lining', true, visibility);
  updateSleeveLinings();
}

// Add collar update function after the other update functions
function updateCollar(styleKey) {
  const collarMap = {
    'Unconstructed': '00mm_collar',
    'Lightly_Padded': '2mm_collar'
  };

  currentCollar = styleKey;
  updateVariant('Collar', collarMap[styleKey]);
}

///End of update functions

async function fetchFabrics() {
    const response = await axios.get(
        "https://grand-le-mar.lc.webdevprojects.cloud/api/v1/fetch/fabrics"
    );
    allfabrics = response.data.data;
    const fid = response.data.data?.filter(
        (fabric) => fabric.id === defaultfabriccode
    );
    sCurruntFabric = fid[0];
    updateFabric(sCurruntFabric ?? DEFAULT_FABRIC_FALLBACK);
}


const fabricLists = document.querySelectorAll(".cm-card-list fabric-list");

if (fabricLists.length > 0) {
    const firstFabricList = fabricLists[0];
    const contentWrapper = firstFabricList.querySelector(
        ".cm-card-content-wrapper"
    );

    if (contentWrapper) {
        const fabricId = contentWrapper.getAttribute("data-fabricid");
        defaultfabriccode = fabricId;
        //console.log("First fabric ID:", fabricId);
    } else {
        //console.log("No content wrapper found within the first fabric-list tag.");
    }
} else {
    //console.log("No fabric-list tags found.");
}

fabricLists.forEach((fabricList) => {
    fabricList.addEventListener("click", function () {
        //console.log("clicked on fabric");
        const contentWrapper = this.querySelector(".cm-card-content-wrapper");
        if (contentWrapper) {
            const fabricId = contentWrapper.getAttribute("data-fabricid");
            const fid = allfabrics?.filter((fabric) => fabric.id === fabricId);

            sCurruntFabric = fid[0];
            updateFabric(fid?.[0] ?? DEFAULT_FABRIC_FALLBACK);
        } else {
            console.log(
                "No content wrapper found within the clicked fabric-list tag."
            );
        }
    });
});

/**
 * @param {THREE.Texture} colorTexture
 * @param {THREE.Texture} normalTexture
 * @param {Array} targetGroups
 * @param {Object} materialOptions
 * @param {Array} excludeGroups
 */
function applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions = {}, excludeGroups = ['Buttons', 'lining', 'button']) {
  if (!suitGroup || !targetGroups || targetGroups.length === 0) return;

  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;
    // ... more code not shown ...

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = maxAnisotropy;

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Function to check if a mesh belongs to target groups
  function isTargetGroup(mesh) {
    if (!mesh.name) return false;

    // Check if mesh is in exclude groups
    if (excludeGroups.some(exclude => mesh.name.toLowerCase().includes(exclude.toLowerCase()))) {
      return false;
    }

    // Check if mesh is in target groups
    return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
  }

  // Function to check if a mesh belongs to target groups (including parent hierarchy)
  function isInTargetGroup(mesh) {
    if (isTargetGroup(mesh)) return true;

    let parent = mesh.parent;
    while (parent) {
      if (isTargetGroup(parent)) return true;
      parent = parent.parent;
    }
    return false;
  }

  // Function to apply textures to a mesh
  function applyTexturesToMesh(mesh) {
    if (mesh.isMesh && mesh.material && isInTargetGroup(mesh)) {
      mesh.material.map = colorTexture;
      if (normalTexture) {
        mesh.material.normalMap = normalTexture;
        mesh.material.normalMap.needsUpdate = true;
      }

      mesh.material.polygonOffset = true;
      mesh.material.polygonOffsetFactor = 1;
      mesh.material.polygonOffsetUnits = 1;

      mesh.material.depthWrite = true;
      mesh.material.depthTest = true;
      mesh.material.roughness = 1;
      mesh.material.metalness = 0.5;

      mesh.material.needsUpdate = true;
    }
  }

  // Traverse and apply textures
  suitGroup.traverse((child) => {
    applyTexturesToMesh(child);
  });
}


function applyTexturesToGroupsWithMaterialConstraint(colorTexture, normalTexture, targetGroups, materialOptions = {}, excludeGroups = [], excludeMaterialName = '', type) {
  if (!suitGroup || !targetGroups || targetGroups.length === 0) return;

  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = maxAnisotropy

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Function to check if a mesh belongs to target groups
  function isTargetGroup(mesh) {
    if (!mesh.name) return false;

    // Check if mesh is in exclude groups
    if (excludeGroups.some(exclude => mesh.name.toLowerCase().includes(exclude.toLowerCase()))) {
      return false;
    }

    // Check if mesh is in target groups
    return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
  }

  // Function to check if a mesh belongs to target groups (including parent hierarchy)
  function isInTargetGroup(mesh) {
    if (isTargetGroup(mesh)) return true;

    let parent = mesh.parent;
    while (parent) {
      if (isTargetGroup(parent)) return true;
      parent = parent.parent;
    }
    return false;
  }

  // Function to check if material name should be excluded
  function shouldExcludeMaterial(mesh) {
    if (!excludeMaterialName || !mesh.material) return false;

    // Check if material name matches the exclude pattern
    return mesh.material.name === excludeMaterialName;
  }

  // Function to apply textures to a mesh
  function applyTexturesToMesh(mesh) {
    if (mesh.isMesh && mesh.material && isInTargetGroup(mesh) && !shouldExcludeMaterial(mesh)) {
      mesh.material.map = colorTexture;
      if (normalTexture) {
        mesh.material.normalMap = normalTexture;
        mesh.material.normalMap.needsUpdate = true;
      }

      // mesh.material.polygonOffset = true;
      // mesh.material.polygonOffsetFactor = 1;
      // mesh.material.polygonOffsetUnits = 1;

      // mesh.material.depthWrite = true;
      // mesh.material.depthTest = true;
      mesh.material.roughness = 1;
      mesh.material.metalness = 0;

      if(type === 'buttonFab'){
      mesh.material.color.setScalar(0.45); // 45% darker
      }

      mesh.material.needsUpdate = true;
    }
  }

  // Traverse and apply textures
  suitGroup.traverse((child) => {
    applyTexturesToMesh(child);
  });
}

/**
 * Load and apply fabric textures to the model
 * @param {string} colorTextureUrl - URL or path to the fabric color texture
 * @param {string} normalTextureUrl - URL or path to the fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyFabric(colorTextureUrl, normalTextureUrl, materialOptions = {}, targetGroups = ['Front', 'Shoulder', 'Collar', 'back', 'ChestPocket', 'Sidepocket', 'Sleeve_design', 'pleat', 'belt'], excludeGroups = ['Buttons', 'lining', 'button']) {
    const textureLoader = new THREE.TextureLoader();
    let colorTextureLoaded = false;
    let normalTextureLoaded = false;
    let colorTexture, normalTexture;

    // If no normal texture, treat it as "loaded" so color alone can apply.
    if (!normalTextureUrl) {
        normalTextureLoaded = true;
        normalTexture = null;
    }
    // ... more code not shown ...

    // Load color texture
    textureLoader.load(
        colorTextureUrl,
        (texture) => {
            colorTexture = texture;
            colorTextureLoaded = true;

            if (colorTextureLoaded && normalTextureLoaded) {
                applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
            }
        },
        undefined,
        (error) => {
            console.error('❌ Error loading color texture:', error);
            // Fallback to default fabric texture (if provided and not already used)
            if (DEFAULT_FABRIC_TEXTURE_URL && colorTextureUrl !== DEFAULT_FABRIC_TEXTURE_URL) {
                textureLoader.load(
                    DEFAULT_FABRIC_TEXTURE_URL,
                    (texture) => {
                        colorTexture = texture;
                        colorTextureLoaded = true;
                        if (colorTextureLoaded && normalTextureLoaded) {
                            applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
                        }
                    },
                    undefined,
                    (fallbackError) => {
                        console.error('❌ Error loading DEFAULT fabric texture:', fallbackError);
                    }
                );
            }
        }
    );

    // Load normal texture
    if (normalTextureUrl) {
        textureLoader.load(
            normalTextureUrl,
            (texture) => {
                normalTexture = texture;
                normalTextureLoaded = true;

                if (colorTextureLoaded && normalTextureLoaded) {
                    applyTexturesToGroups(colorTexture, normalTexture, targetGroups, materialOptions, excludeGroups);
                    // Force a second application after a short delay to ensure consistency
                    setTimeout(() => {
                        // Removed buttonhole lapel texture application as lapel functionality is removed
                    }, 100);
                }
            },
            undefined,
            (error) => {
                console.error('❌ Error loading normal texture:', error);
                // Still allow color-only application
                normalTextureLoaded = true;
                normalTexture = null;
                if (colorTextureLoaded && normalTextureLoaded) {
                    applyTexturesToGroups(colorTexture, null, targetGroups, materialOptions, excludeGroups);
                }
            }
        );
    }
}

// Add fabric update function
function updateFabric(fabric) {
    // Support either a fabric object or a fabric id string.
    const resolvedFabric =
        typeof fabric === "string"
            ? (allfabrics?.find((f) => f.id === fabric) ?? DEFAULT_FABRIC_FALLBACK)
            : (fabric ?? DEFAULT_FABRIC_FALLBACK);

    const colorUrl =
        resolvedFabric?.repeatable_color_image_url || DEFAULT_FABRIC_TEXTURE_URL;
    const normalUrl = resolvedFabric?.repeatable_normal_image_url || null;

    if (!colorUrl) {
        console.warn("No fabric color texture URL found (and no default provided).");
        return;
    }

    // Load and apply the new fabric
    loadAndApplyFabric(colorUrl, normalUrl, { repeat: [30, 30] });

    // Apply the same fabric to Thread_Mat materials
    if (resolvedFabric?.repeatable_normal_image_url) {
        loadAndApplyThreadFabric(colorUrl, normalUrl, { repeat: [30, 30] });
    } else {
        // If we don't have a normal map, still apply the color texture to threads
        loadAndApplyThreadFabric(colorUrl, colorUrl, { repeat: [30, 30] });
    }
}

// Add button fabric update function
function updateButtonFabric(fabricKey) {
  // Load and apply the new button fabric
  loadAndApplyButtonFabric(fabricKey, null, {
    repeat: [1, 1],
  });
}

// Add lining fabric update function
function updateLiningFabric(fabric) {
  // Load and apply the new lining fabric
  loadAndApplyLiningFabric(fabric);
}

// ----- Update On Config Change -----
function handleConfigChange(event, value) {

  if (event === 'shoulder') {
    updateShoulder(value);
    updateVent();
    invertedBoxPleat();
    updateVentOptions();
  }

  if (event === 'inverted-box-pleat') {
    currentInvertedBoxPleat = value;
    invertedBoxPleat(value);
    updateVentOptions();
  }

  if (event === 'martingale-belt') {
    const isVisible = value === 'true';
    currentMartingaleBelt = value;
    martingaleBelt(value, isVisible);
    updateVentOptions();
  }

  if (event === 'chest-pocket') {
    updateChestPocket(value);
  }

  if (event === 'side-pocket') {
    updateSidePocket(value);
  }

  if (event === 'sleeve-design') {
    updateSleeveDesign(value);
  }

  if (event === 'lining') {
      updateLinings(value);
  }
}

/**
 * @param {string} colorTextureUrl
 * @param {string} normalTextureUrl
 * @param {Object} materialOptions
 */
function loadAndApplyButtonFabric(colorTextureUrl, normalTextureUrl, materialOptions = {}) {
  const textureLoader = new THREE.TextureLoader();
  let colorTextureLoaded = false;
  let normalTextureLoaded = false;
  let colorTexture, normalTexture;

  // Load color texture
  textureLoader.load(
    `https://grand-le-mar-uploads-2.s3.ap-south-1.amazonaws.com/buttons/overcoat/${colorTextureUrl}.png`,
    (texture) => {
      colorTexture = texture;
      colorTextureLoaded = true;
      if (colorTextureLoaded) {
        applyTexturesToGroupsWithMaterialConstraint(
          colorTexture,
          normalTextureUrl ? normalTexture : null,
          [
            'Buttons', '2_Buttons', '6_buttons', 'belt_button', 'belt_buttons',
            'pleat_buttons', 'sleave_buttons', 'sec_strap', 'one_strap_button', 'pleat_button'
          ],
          materialOptions,
          [
            'Full_Sleeve_Strap_with_buttons',
            'Sleeve_Eqaulettes003',
            'one_strap002'
          ],
          'Thread_Mat', "buttonFab"
        );
      }
    },
    undefined,
    (error) => console.error('❌ Error loading button color texture:', error)
  );
}


/**
 * Load and apply lining fabric textures
 * @param {string} colorTextureUrl - URL or path to the lining fabric color texture
 * @param {string} normalTextureUrl - URL or path to the lining fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyLiningFabric(color) {
  // Accepts color as a string (e.g., "#ff0000" or "0xff0000") or a THREE.Color object
  if (!suitGroup) return;

  let resolvedColor = color;

  // Traverse suitGroup and apply color to lining mesh/materials
  const targetGroups = ["lining", "Lining"];
  const excludeGroups = ['Front', 'Shoulder', 'vent', 'ChestPocket', 'Sidepocket', 'Sleeve_design', 'Inverted_Box_Pleat', 'Martingale_Belt', 'Buttons'];

  function isTargetLiningMesh(mesh) {
    if (!mesh.name) return false;
    // Exclude unwanted groups
    if (excludeGroups.some(ex => mesh.name.toLowerCase().includes(ex.toLowerCase()))) {
      return false;
    }
    // Include wanted groups
    return targetGroups.some(target => mesh.name.toLowerCase().includes(target.toLowerCase()));
  }

  function isInTargetGroup(mesh) {
    if (isTargetLiningMesh(mesh)) return true;
    let parent = mesh.parent;
    while (parent) {
      if (isTargetLiningMesh(parent)) return true;
      parent = parent.parent;
    }
    return false;
  }

  suitGroup.traverse((child) => {
    if (child.isMesh && child.material && isInTargetGroup(child)) {
      // Apply color directly
      if (child.material.color) {
        child.material.color.set(color);
        child.material.needsUpdate = true;
      }
    }
  });
}

/**
 * Load and apply fabric textures specifically to Thread_Mat materials
 * @param {string} colorTextureUrl - URL or path to the fabric color texture
 * @param {string} normalTextureUrl - URL or path to the fabric normal texture
 * @param {Object} materialOptions - Additional material properties
 */
function loadAndApplyThreadFabric(colorTextureUrl, normalTextureUrl, materialOptions = {}) {
  const textureLoader = new THREE.TextureLoader();
  let colorTextureLoaded = false;
  let normalTextureLoaded = false;
  let colorTexture, normalTexture;

  // Load color texture
  textureLoader.load(
    colorTextureUrl,
    (texture) => {
      colorTexture = texture;
      colorTextureLoaded = true;

      if (colorTextureLoaded && normalTextureLoaded) {
        applyTexturesToThreadMaterials(colorTexture, normalTexture, materialOptions);
      }
    },
    undefined,
    (error) => {
      console.error('❌ Error loading thread color texture:', error);
    }
  );

  // Load normal texture
  textureLoader.load(
    normalTextureUrl,
    (texture) => {
      normalTexture = texture;
      normalTextureLoaded = true;

      if (colorTextureLoaded && normalTextureLoaded) {
        applyTexturesToThreadMaterials(colorTexture, normalTexture, materialOptions);
      }
    },
    undefined,
    (error) => {
      console.error('❌ Error loading thread normal texture:', error);
    }
  );
}

/**
 * Apply textures specifically to Thread_Mat materials
 * @param {THREE.Texture} colorTexture
 * @param {THREE.Texture} normalTexture
 * @param {Object} materialOptions
 */
function applyTexturesToThreadMaterials(colorTexture, normalTexture, materialOptions = {}) {
  if (!suitGroup) return;

  // Configure texture settings
  const configureTexture = (texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.encoding = THREE.sRGBEncoding;

    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
    texture.anisotropy = maxAnisotropy;

    texture.generateMipmaps = true;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;

    const repeatX = materialOptions.repeat?.[0] || 10;
    const repeatY = materialOptions.repeat?.[1] || 10;
    texture.repeat.set(repeatX, repeatY);
  };

  // Configure both textures
  configureTexture(colorTexture);
  if (normalTexture) {
    configureTexture(normalTexture);
  }

  // Function to apply textures to Thread_Mat materials
  function applyTexturesToThreadMesh(mesh) {
    if (mesh.isMesh && mesh.material && mesh.material.name === 'Thread_Mat') {
      mesh.material.map = colorTexture;
      if (normalTexture) {
        mesh.material.normalMap = normalTexture;
        mesh.material.normalMap.needsUpdate = true;
      }

      mesh.material.polygonOffset = true;
      mesh.material.polygonOffsetFactor = 1;
      mesh.material.polygonOffsetUnits = 1;

      mesh.material.depthWrite = true;
      mesh.material.depthTest = true;
      mesh.material.roughness = 1;
      mesh.material.metalness = 0.5;

      mesh.material.needsUpdate = true;
    }
  }

  // Traverse and apply textures to Thread_Mat materials
  suitGroup.traverse((child) => {
    applyTexturesToThreadMesh(child);
  });
}

// ----- Show/Hide UI Functions -----
function showConfigurationUI() {
  currentScreen = 'config';
  document.getElementById('fabric-selection-screen').style.display = 'none';
  document.getElementById('config-sidebar').style.display = 'flex';

  // Initialize the configuration UI if not already done
  if (!window.configUIInitialized) {
    initConfigUI();
    window.configUIInitialized = true;
  }
}

function showFabricSelectionUI() {
  currentScreen = 'fabric-selection';
  document.getElementById('config-sidebar').style.display = 'none';
  document.getElementById('fabric-selection-screen').style.display = 'flex';
}

// ----- Initialize DOM Selectors & Events -----
function initConfigUI() {
  setTimeout(() => {
  let parentDivs = document.querySelectorAll(".cm-modifier-card-container");
  let resultTitleText, resultTitleTextWithoutSpaces, childDiv, resultTitleDiv, filter_label, filter_label_value;

  if(dataPageValue === "custom-made-raglan-coat"){
            for (let i = 0; i < parentDivs.length; i++) {
                childDiv = parentDivs[i].querySelector(".cm-modifier-card-wrapper");

                if (childDiv) {
                    filter_label = childDiv.querySelector(".cm-modifier-col-title");
                    resultTitleDiv = childDiv.querySelector(".cm-modifier-result-title");

                    if (resultTitleDiv) {
                        resultTitleText = resultTitleDiv.textContent.trim();
                        filter_label_value = filter_label.textContent.trim();
                        resultTitleTextWithoutSpaces = resultTitleText.replace(
                            /[.\s:]+/g,
                            "_"
                        );
                        filter_label_value = filter_label_value.replace(
                            /[.\s:]+/g,
                            "_"
                        );

                        if(filter_label_value === 'Buttoning'){
                          if(resultTitleTextWithoutSpaces === "Raglan_Shoulder_-_Unconstructed_(0_mm)"){
                            currentButtoning = 'single_breasted_2'
                          }
                          if(resultTitleTextWithoutSpaces === "Double_Breasted_6_button"){
                            currentButtoning = 'double_breasted_6'
                          }
                          handleConfigChange('buttoning',currentButtoning)
                        }
                        
                        if(filter_label_value === 'Lapel_style'){
                          if(resultTitleTextWithoutSpaces === "Peak"){
                            currentLapelStyle = 'peak'
                          }
                          if(resultTitleTextWithoutSpaces === "Notch"){
                            currentLapelStyle = 'notch'
                          }
                          if(resultTitleTextWithoutSpaces === "Notch_Peak"){
                            currentLapelStyle = 'notchpeak'
                          }
                          handleConfigChange('lapel-style',currentLapelStyle)
                        }

                        if(filter_label_value === 'Shoulder'){
                          if(resultTitleTextWithoutSpaces === "Raglan_Shoulder_-_Unconstructed_(0_mm)"){
                            currentShoulder = 'Unconstructed'
                          }

                          handleConfigChange('shoulder',currentShoulder)
                        }

                        if(filter_label_value === 'Inverted_box_pleat'){
                          if(resultTitleTextWithoutSpaces === 'Yes'){
                            currentInvertedBoxPleat = true
                          }
                          if(resultTitleTextWithoutSpaces === 'No'){
                            currentInvertedBoxPleat = false
                          }
                          handleConfigChange('inverted-box-pleat',currentInvertedBoxPleat)
                        }

                        if(filter_label_value === 'Martingale_belt'){
                          if(resultTitleTextWithoutSpaces === 'Yes'){
                            currentMartingaleBelt = true
                          }
                          if(resultTitleTextWithoutSpaces === 'No'){
                            currentMartingaleBelt = false
                          }

                          handleConfigChange('martingale-belt',currentMartingaleBelt)
                        }

                        if(filter_label_value === 'Vent'){
                          
                          if(resultTitleTextWithoutSpaces === 'Single'){
                            currentVent = 'single'
                          }
                          if(resultTitleTextWithoutSpaces === 'Single_with_buttons'){
                            currentVent = 'vent_Single_with_Button'
                          }
                          handleConfigChange('vent',currentVent)
                        }

                        if(filter_label_value === 'Chest_pocket'){
                          if(resultTitleTextWithoutSpaces === 'Boat'){
                            currentChestPocket = 'boat'
                          }
                          if(resultTitleTextWithoutSpaces === 'None'){
                            currentChestPocket = 'none'
                          }
                          handleConfigChange('chest-pocket',currentChestPocket)
                        }

                        if(filter_label_value === 'Side_pockets'){
                          if(resultTitleTextWithoutSpaces === 'Slanted_Welt'){
                            currentSidePocket = 'slanted-welt'
                          }
                          if(resultTitleTextWithoutSpaces === 'Slanted_Welt_with_button'){
                            currentSidePocket = 'slanted-welt-buttons'
                          }
                          handleConfigChange('side-pocket',currentSidePocket)
                        }
                        
                        if(filter_label_value === 'Buttons'){
                         currentButtonfab = resultTitleTextWithoutSpaces
                          loadAndApplyButtonFabric(currentButtonfab, null, {repeat: [1, 1]})
                        }
                        
                        if(filter_label_value === 'Sleeve_design'){
                          if(resultTitleTextWithoutSpaces === 'Sleeve_Strap'){
                            currentSleeveDesign = 'sleeve-strap'
                          }
                          if(resultTitleTextWithoutSpaces === 'Full_Sleeve_Strap_with_buttons'){
                            currentSleeveDesign = 'sleeve-strap-with-buttons'
                          }
                          handleConfigChange('sleeve-design',currentSleeveDesign)
                        }

                        if(filter_label_value === 'Lining'){
                          if(resultTitleTextWithoutSpaces === 'Unlined'){
                            currentLinings = false
                          }else{
                            currentLinings = true
                          }

                          handleConfigChange('lining',currentLinings)
                        }

                        if(filter_label_value === 'Lining_colour'){
                          currentLiningsColor = getLiningColor(resultTitleTextWithoutSpaces)
                          handleLiningFabricChange(currentLiningsColor)

                        }

                        if(filter_label_value === 'Buttonhole_lapel_position'){
                          if(resultTitleTextWithoutSpaces === 'Left_(Standard)'){
                            currentButtonholeLapelPosition = 'left'
                          }
                          if(resultTitleTextWithoutSpaces === 'Right'){
                            currentButtonholeLapelPosition = 'right'
                          }
                          if(resultTitleTextWithoutSpaces === 'Both'){
                            currentButtonholeLapelPosition = 'both'
                          }

                          if(resultTitleTextWithoutSpaces === 'None'){
                            currentButtonholeLapelPosition = 'none'
                          }
                          handleConfigChange('buttonhole-lapel-position',currentButtonholeLapelPosition)
                        }

                        if(filter_label_value === 'Buttonhole_lapel'){
                          let selectedButtonholeLapel = currentButtonholeLapel;
                            if (resultTitleTextWithoutSpaces === 'Handmade_milanese') {
                                selectedButtonholeLapel = 'handmade-milanese';
                            }
                            if (resultTitleTextWithoutSpaces === 'Traditional') {
                                selectedButtonholeLapel = 'traditional';
                            }

                            currentButtonholeLapel = selectedButtonholeLapel;
                            handleConfigChange('buttonhole-lapel', selectedButtonholeLapel);
                        }

                        // if(filter_label_value === 'Overcoat'){

                        // }


                        // handleConfigChange(filter_label_value, resultTitleTextWithoutSpaces)
                    }
                  }
              }
  }

},450)
}

function updateVentOptions() {
}

// Add button fabric change handler
function handleButtonFabricChange(fabricKey) {
  CONFIG.defaults.buttonFabric = fabricKey;
  updateButtonFabric(fabricKey);
}

// Add lining fabric change handler
function handleLiningFabricChange(fabricKey) {
  CONFIG.defaults.liningFabric = fabricKey;
  updateLiningFabric(fabricKey);
}

// ----- Init Everything on Load -----
// document.addEventListener('DOMContentLoaded', () => {
//   initThree();
//   loadJacketModel('https://grand-le-mar-media-2.s3.ap-south-1.amazonaws.com/Raglan.glb');

//   // Set default fabric selection
//   // selectedMainFabric = CONFIG.defaults.fabric;
//   // updateFabric(selectedMainFabric);

//   // updateVentOptions();
// });


function getLiningColor(color_code) {
    switch (color_code) {
        case "White":
            return "#FFFFFF";
            break;
        case "Black":
            return "#111111";
            break;
        case "Dark_Navy":
            return "#112139";
            break;
        case "Navy":
            return "#1D1F34";
            break;
        case "Mid_Navy":
            return "#1A2F4C";
            break;
        case "Dark_Grey":
            return "#4D4D4D";
            break;
        case "Light_Grey":
            return "#898989";
            break;
        case "Brown":
            return "#2e241e";
            break;
        case "Light_Blue":
            return "#9AB5C0";
            break;
        case "Light_Brown":
            return "#685037";
            break;
        case "Dark_Brown":
            return "#52402E";
            break;
        case "Beige":
            return "#AB947A";
            break;
        case "Khaki_green":
            return "#453b22";
            break;
        case "Pink":
            return "#9c5a70";
            break;
        case "Burgundy":
            return "#5E1A27";
            break;
        case "Red":
            return "#5A0206";
            break;
        case "Orange":
            return "#A8513C";
            break;
        case "Purple":
            return "#7e4eb5";
            break;
        default:
            return "#FFFFFF";
            break;
    }
}

// ----- Handle Resize -----
window.addEventListener('resize', () => {
  const viewerDiv = document.getElementById('CanvasFrame');
  const viewerWidth = viewerDiv.clientWidth;
  const viewerHeight = viewerDiv.clientHeight;

  camera.left = viewerWidth / -650;
  camera.right = viewerWidth / 650;
  camera.top = viewerHeight / 650;
  camera.bottom = viewerHeight / -650;
  camera.updateProjectionMatrix();
  renderer.setSize(viewerWidth, viewerHeight);
});

$(document).on(
    "click",
    ".cm-modifier-drawer[drawer-type='one'] .drawer1_apply, .cm-modifier-drawer .drawer2_apply, .cm-toggle-ele .cm-toggle-item,.btm_tab .cm-toggle-item,.btn-customize.next_button",
    function (event) {
        var currObj = this;

        // Added by softpulse
        if ($(currObj).parents(".isSelected").find(".is-selected").hasClass("cm-drawer-other-option-btn")) {
            $("body").removeClass("line-loading-3d-preview");
            currObj.classList.contains("inactive_button") ? currObj.classList.remove("inactive_button") : '';
            return;
        }
        if (event.isTrigger) {
            initConfigUI()
        }
    }
);

initThree();